import { ReactNode } from 'react'
import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  format,
  isAfter,
  subDays,
  subHours,
  subMinutes,
} from 'date-fns'
import { ActivityRecruitType } from 'generated/graphql'

export const convertCreatedAtToString = (createdAt: number | Date): string => {
  const NOW = new Date()
  const ONE_MINUTE_AGO = subMinutes(NOW, 1)
  const ONE_HOUR_AGO = subHours(NOW, 1)
  const ONE_DAY_AGO = subHours(NOW, 24)
  const ONE_WEEK_AGO = subDays(NOW, 7)

  const writenInOneMunite = isAfter(createdAt, ONE_MINUTE_AGO)
  const writenInOneHour = isAfter(createdAt, ONE_HOUR_AGO)
  const writenInOneDay = isAfter(createdAt, ONE_DAY_AGO)
  const writenInOneWeek = isAfter(createdAt, ONE_WEEK_AGO)

  if (writenInOneMunite) {
    return '방금 전'
  }
  if (writenInOneHour) {
    return `${differenceInMinutes(NOW, createdAt)}분 전`
  }
  if (writenInOneDay) {
    return `${differenceInHours(NOW, createdAt)}시간 전`
  }
  if (writenInOneWeek) {
    return `${differenceInDays(NOW, createdAt)}일 전`
  }
  return format(createdAt, 'yyyy.MM.dd')
}

export const getRemainingTime = (date: number): number => {
  const nowDate = new Date()
  return differenceInDays(date, nowDate.getTime())
}

export const formatRemainingTimeToString = (
  closedAt?: number,
  recruitType?: ActivityRecruitType,
  type: 'DutyItem' | 'CoverLetterTitle' = 'CoverLetterTitle',
  isOnlyDate = false,
): ReactNode => {
  switch (recruitType) {
    case ActivityRecruitType.ALWAYS:
      return '상시채용'
    case ActivityRecruitType.ASAP:
      return '채용 시 마감'
    case ActivityRecruitType.SCHEDULED:
      return '예정'
    case ActivityRecruitType.NORMAL:
      if (closedAt) {
        const dDay = getRemainingTime(closedAt)

        if (dDay === 0) {
          const hours = differenceInHours(closedAt, new Date())

          if (hours === 0) {
            const minutes = differenceInMinutes(closedAt, new Date())
            return <span style={{ color: '#ff0000' }}>{minutes}분 남음</span>
          }

          if (hours < 0) {
            if (type === 'DutyItem') return '마감'
            return `D+${Math.abs(hours)}시`
          }

          return <span style={{ color: '#ff0000' }}>{hours}시간 남음</span>
        }

        if (dDay < 0) {
          if (type === 'DutyItem') return '마감'
          return `D+${Math.abs(dDay) > 999 ? 999 : Math.abs(dDay)}${
            isOnlyDate ? '' : '일'
          }`
        }
        return `D-${dDay > 999 ? 999 : dDay}${isOnlyDate ? '' : '일'}`
      }
      return '마감일 없음'

    default:
      return '마감일 없음'
  }
}
